module.exports = {"title":"핀","lastUpdated":"최근 업데이트","refresh":"새로고침","selectGolfClubPlaceholder":"골프클럽을 선택하세요.","selectTypePlaceholder":"유형을 선택하세요.","realTimePinPosition":"실시간 핀 위치","periodPinPosition":"기간별 핀 위치","startTime":"시작 시각","duration":"지속 시간","sendPinErrorAlert":"핀 위치 오류 알림 발송","tooltip":"실제 핀 위치와 다를 경우 먼저 최신 업데이트를 진행해 보세요. 여전히 다르다면 운영자에게 메시지를 발송할 수 있습니다.","flag":"깃","confirmSendAlarmMessage":"코스 : {course}<br />홀 : {hole}<br />핀 위치가 실제와 다르다면<br />운영자에게 메세지를 발송하세요.","alarmSent":"발송되었습니다."}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ko/gr301.json
// module id = fBg1
// module chunks = 2